/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";

/**
 *
 * @export
 * @interface PersonEligibleActionDTO
 */
export interface PersonEligibleActionDTOOptional {
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof PersonEligibleActionDTO
   */
  action?: SignupTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof PersonEligibleActionDTO
   */
  isAvailable?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonEligibleActionDTO
   */
  actionError?: string;
}

export interface PersonEligibleActionDTO extends PersonEligibleActionDTOOptional {
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof PersonEligibleActionDTO
   */
  action: SignupTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof PersonEligibleActionDTO
   */
  isAvailable: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonEligibleActionDTO
   */
  actionError?: string;
}

export interface PersonEligibleActionDTOTrackedI {
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof PersonEligibleActionDTO
   */
  action?: SignupTypeEnum;
  actionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonEligibleActionDTO
   */
  isAvailable?: boolean;
  isAvailableIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonEligibleActionDTO
   */
  actionError?: string;
  actionErrorIsSet: boolean;
}

transformDatesMap.set(
  "PersonEligibleActionDTO",
  function (model: PersonEligibleActionDTO) {},
);

export type PersonEligibleActionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  action: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  isAvailable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  actionError: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonEligibleActionDTOMeta: PersonEligibleActionDTOMetaI =
  {} as PersonEligibleActionDTOMetaI;
PersonEligibleActionDTOMeta = typeMeta("PersonEligibleActionDTO", {
  action: propertyMeta("action", false, true, false, SignupTypeEnumMeta),
  isAvailable: propertyMeta(
    "isAvailable",
    false,
    true,
    false,
    MetaTypesBase.boolean,
  ),
  actionError: propertyMeta(
    "actionError",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonEligibleActionDTOMeta;

registerMeta(() => {});

export class PersonEligibleActionDTOTracked implements PersonEligibleActionDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  action__I?: SignupTypeEnum = undefined;
  actionIsSet: boolean = false;
  set action(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.action__I = v;
      this.actionIsSet = true;
    } else {
      this.action__I = v || undefined;
      this.actionIsSet = true;
    }
    this.changeTracker = true;
  }
  get action() {
    return this.action__I;
  }
  isAvailable__I?: boolean = undefined;
  isAvailableIsSet: boolean = false;
  set isAvailable(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAvailable__I = v;
      this.isAvailableIsSet = true;
    } else {
      this.isAvailable__I = v || undefined;
      this.isAvailableIsSet = true;
    }
    this.changeTracker = true;
  }
  get isAvailable() {
    return this.isAvailable__I;
  }
  actionError__I?: string = undefined;
  actionErrorIsSet: boolean = false;
  set actionError(v: undefined | string) {
    if (v !== undefined) {
      this.actionError__I = v;
      this.actionErrorIsSet = true;
    } else {
      this.actionError__I = v || undefined;
      this.actionErrorIsSet = false;
    }
    this.changeTracker = true;
  }
  get actionError() {
    return this.actionError__I;
  }
  constructor(
    config?: PersonEligibleActionDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonEligibleActionDTOOptional,
    options?: AssignOptions,
  ): PersonEligibleActionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.action && this.actionApplyFilter(optionsRequired.filter)) {
      this.action = config.action;
      if (optionsRequired.unassign) this.actionIsSet = false;
      else this.actionIsSet = true;
    }
    if (
      config.isAvailable &&
      this.isAvailableApplyFilter(optionsRequired.filter)
    ) {
      this.isAvailable = config.isAvailable;
      if (optionsRequired.unassign) this.isAvailableIsSet = false;
      else this.isAvailableIsSet = true;
    }
    if (
      config.actionError &&
      this.actionErrorApplyFilter(optionsRequired.filter)
    ) {
      this.actionError = config.actionError;
      if (optionsRequired.unassign) this.actionErrorIsSet = false;
      else this.actionErrorIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonEligibleActionDTOTrackedI {
    const cloned = {} as PersonEligibleActionDTOTrackedI;
    if (
      this.actionIsSetDeep() &&
      this.actionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.actionIsSet = true;
      cloned.action = this.action;
    } else {
      //cloned.actionIsSet = false
    }
    if (
      this.isAvailableIsSetDeep() &&
      this.isAvailableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAvailableIsSet = true;
      cloned.isAvailable = this.isAvailable;
    } else {
      //cloned.isAvailableIsSet = false
    }
    if (
      this.actionErrorIsSetDeep() &&
      this.actionErrorApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.actionErrorIsSet = true;
      cloned.actionError = this.actionError;
    } else {
      //cloned.actionErrorIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonEligibleActionDTOTrackedI {
    if (!this.actionApplyFilter(filter)) this.actionIsSet = false;

    if (!this.isAvailableApplyFilter(filter)) this.isAvailableIsSet = false;

    if (!this.actionErrorApplyFilter(filter)) this.actionErrorIsSet = false;

    return this;
  }
  actionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonEligibleActionDTOMeta.action,
      PersonEligibleActionDTOMeta,
      this.action,
      this,
    );
  }
  actionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.actionIsSet && this.actionApplyFilter(filter)) return true;

    return false;
  }
  isAvailableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonEligibleActionDTOMeta.isAvailable,
      PersonEligibleActionDTOMeta,
      this.isAvailable,
      this,
    );
  }
  isAvailableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAvailableIsSet && this.isAvailableApplyFilter(filter))
      return true;

    return false;
  }
  actionErrorApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonEligibleActionDTOMeta.actionError,
      PersonEligibleActionDTOMeta,
      this.actionError,
      this,
    );
  }
  actionErrorIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.actionErrorIsSet && this.actionErrorApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.actionIsSetDeep(filter)) return true;
    if (this.isAvailableIsSetDeep(filter)) return true;
    if (this.actionErrorIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
